import styled from 'styled-components';
import { a as arrowStyleMixin } from './mixins/arrow-4a70f2f1.js';
import { s as surfaceStyleMixin } from './mixins/surface-4937b36f.js';
import { f as focusOutlineMixin } from '../FocusIndicator/styleMixins/focusOutline-ae6f4c7f.js';
import { P as PortalComponent } from '../Portal/PortalComponent-56d5ee46.js';

const PopperArrow = /*#__PURE__*/styled('div').withConfig({
  componentId: "sc-storm-ui-30039089__sc-may1nv-0"
})(["", ""], arrowStyleMixin);
PopperArrow.displayName = 'PopperArrow';
const PopperTrigger = /*#__PURE__*/styled.span.withConfig({
  componentId: "sc-storm-ui-30039089__sc-may1nv-1"
})(["display:inline-block;width:fit-content;"]);
PopperTrigger.displayName = 'PopperTrigger';
const TRANSITION_CLASSNAME_PREFIX = 'popper-surface-transition';
const PopperSurface = /*#__PURE__*/styled('div').withConfig({
  componentId: "sc-storm-ui-30039089__sc-may1nv-2"
})(["", " :focus{", "}:focus-visible{", "}@media (prefers-reduced-motion:no-preference){transition:opacity ", "ms ease-in-out;}opacity:0;&.", "-appear{opacity:0;}&.", "-appear-active{opacity:1;}&.", "-appear-done{opacity:1;}&.", "-enter{opacity:1;}&.", "-enter-active{opacity:1;}&.", "-enter-done{opacity:1;}&.", "-exit{opacity:0;}&.", "-exit-active{opacity:0;}&.", "-exit-done{opacity:0;}", " > &&{width:max-content;}"], surfaceStyleMixin, focusOutlineMixin, focusOutlineMixin, ({
  $transitionDuration
}) => $transitionDuration, TRANSITION_CLASSNAME_PREFIX, TRANSITION_CLASSNAME_PREFIX, TRANSITION_CLASSNAME_PREFIX, TRANSITION_CLASSNAME_PREFIX, TRANSITION_CLASSNAME_PREFIX, TRANSITION_CLASSNAME_PREFIX, TRANSITION_CLASSNAME_PREFIX, TRANSITION_CLASSNAME_PREFIX, TRANSITION_CLASSNAME_PREFIX, /* only apply `width: max-content;` to Poppers that are children of Poppers */
PortalComponent);
PopperSurface.displayName = 'PopperSurface';

export { PopperTrigger as P, TRANSITION_CLASSNAME_PREFIX as T, PopperSurface as a, PopperArrow as b };
//# sourceMappingURL=Popper.styles-3041670f.js.map
